import { motion, useAnimation } from "framer-motion";
import React, { useEffect, useState } from "react";
import Button from "../../shared/components/ui/Button";
import { Box } from "../../shared/components/ui/chakra";
import ThumbUpFilledIcon from "../../shared/components/icons/ThumbUpFilledIcon";
import ThumbUpIcon from "../../shared/components/icons/ThumbUpIcon";
import useRequest from "../../shared/lib/useRequest";

import { HStack, Text } from "@chakra-ui/react";

const NewUsefulButton = ({
  useful: propUseful,
  count: propCount,
  path,
  isDisabled = false,
}: {
  useful: boolean;
  count: number;
  path: string;
  isDisabled?: boolean;
}) => {
  const [useful, setUseful] = useState(propUseful);
  const [count, setCount] = useState(propCount);
  const [animate, setAnimate] = useState(false);
  const request = useRequest();

  const toggleUseful = async () => {
    if (useful) {
      setAnimate(false);
      setCount(count - 1);
      await request(path, "DELETE");
    } else {
      setAnimate(true);
      setCount(count + 1);
      await request(path, "PUT");
    }
    setUseful(!useful);
  };

  return (
    <UI
      useful={useful}
      count={count}
      animate={animate}
      onClick={isDisabled ? undefined : toggleUseful}
    />
  );
};

const UI = ({
  useful,
  count,
  animate,
  onClick,
}: {
  useful: boolean;
  count: number;
  animate: boolean;
  onClick: (() => void) | undefined;
}) => {
  const controls = useAnimation();
  useEffect(() => {
    if (animate) {
      void controls.start({
        scale: [1, 1.3, 1.6, 1.3, 1],
        rotate: ["-5deg", "0deg", "10deg", "-10deg", "10deg", "-10deg", "0deg"],
      });
    }
  }, [animate, controls]);
  const props = onClick
    ? {}
    : {
        bgColor: undefined,
        color: undefined,
        cursor: "default",
      };
  return (
    <Button
      leftIcon={
        <Box as={motion.div} animate={controls}>
          {useful ? (
            <ThumbUpFilledIcon boxSize={5} />
          ) : (
            <ThumbUpIcon boxSize={5} />
          )}
        </Box>
      }
      borderRadius={4}
      px={2}
      py={1}
      variant={useful ? "solid" : "outline"}
      onClick={onClick}
      iconSpacing={1}
      _hover={props}
    >
      <HStack pt={0.5} fontSize="sm" gap={1.5}>
        {count > 0 && <Text lineHeight="1">{count}</Text>}
        <Text lineHeight="1">参考になった</Text>
      </HStack>
    </Button>
  );
};

export default NewUsefulButton;
